var url = document.location.href;
var upstack;

if (url.includes('apply-v2') || url.includes('apply.html') || url.includes('apply-v3') || url.includes('apply3.html')) {
  upstack = angular.module('upstack', ['ngSanitize', 'angular.filter', 'ui.select', 'ui.router']);

  upstack.config(['$locationProvider', '$stateProvider', function ($locationProvider, $stateProvider) {
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });

    // /company/apply2
    $stateProvider
      .state('apply', {
        url: '/company/apply-v2/:parent/:child',
        controller: 'applyCtrl as vm',
        template: '',
        title: 'Apply',
        params: {
          parent: {value: '', squash: true},
          child: {value: '', squash: true}
        }
      })
      .state('apply3', {
        url: '/company/apply-v3/:parent/:child',
        controller: 'apply3Ctrl as vm',
        template: '',
        title: 'Apply',
        params: {
          parent: {value: '', squash: true},
          child: {value: '', squash: true}
        }
      });
  }]);
} else {
  upstack = angular.module('upstack', ['ngSanitize', 'angular.filter', 'ui.select']);

  upstack.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
  }]);
}

upstack.service('MetaTags', function () {
  var metaKeywords = 'Hire a remote developer';
  var noIndex = false;
  return {
    set: function (keywords, disableIndex) {
      metaKeywords = keywords ? keywords : metaKeywords;
      noIndex = !!disableIndex;
    },
    metaKeywords: function () {
      return metaKeywords;
    },
    noIndex: function () {
      return !!noIndex;
    }
  };
});

upstack.directive('lazyLoad', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var observer = new IntersectionObserver(loadImg);
      var img = angular.element(element)[0];
      observer.observe(img);

      function loadImg(changes) {
        changes.forEach(function (change) {
          if (change.intersectionRatio > 0) {
            if (attrs.type) {
              change.target.srcset = attrs.lazyLoad;
            } else {
              change.target.src = attrs.lazyLoad;
            }

          }
        })
      }
    }
  }
});

function initSkrollr() {
  return skrollr.init({
    forceHeight: false,
    smoothScrolling: true,
    render: function (data) {
      var top = data.curTop;

      if (data.curTop > 60)
        $('body').addClass('fixed');
      else
        $('body').removeClass('fixed');

      elements.forEach(function (v, k) {
        if (v.length) {
          if (parseInt(v.offset().top) < parseInt($(window).height() - v.height()))
            v.addClass('active');

          if (v.selector == '.kpi' && parseInt(v.offset().top) < parseInt($(window).height() - v.height())) {
            counter(developers, 300, 5, 500, 200, '', '+');
            counter(interviews, 15, 5, 500, 200, 'k', '+');
            counter(countries, 20, 5, 500, 200, '', '+');
          }

          if (v.selector == '.worldStats' && parseInt(v.offset().top) < parseInt($(window).height())) {
            stats.forEach(function (item, index) {
              counter($(item.name), item.to, 5, 1000, 200, '%', '');
            });
          }

          if (v.selector == '.top1' && parseInt(v.offset().top) < parseInt($(window).height())) {
            $('.top1 figure .green').addClass('fadeInUpBig');
            setTimeout(function () {
              $('.top1 figure .blue').addClass('fadeInUpBig');
            }, 300);
            setTimeout(function () {
              $('.top1 figure .red').addClass('fadeInUpBig');
            }, 600);
            setTimeout(function () {
              $('.top1 figure .lightblue').addClass('fadeInUpBig');
            }, 900);
            setTimeout(function () {
              $('.top1 figure .yellow').addClass('fadeInUpBig');
            }, 1200);
            setTimeout(function () {
              $('.top1 figure .user-star').addClass('fadeInUpBig');
            }, 1500);
          }

          if (v.selector == '.topCompanies' && parseInt(v.offset().top) < parseInt($(window).height())) {
            var i = 0;
            $('.topCompanies div').each(function () {
              var self = this;
              setTimeout(function () {
                $(self).find('img').addClass('animated zoomInDown');
              }, i);
              i += 100;
            });
          }

          if (v.selector == '.worldMap' && parseInt(v.offset().top) < parseInt($(window).height())) {
            setTimeout(function () {
              $('.worldMap .green').addClass('active');
            }, 300);
            setTimeout(function () {
              $('.worldMap .red').addClass('active');
            }, 600);
            setTimeout(function () {
              $('.worldMap .pink').addClass('active');
            }, 900);
            setTimeout(function () {
              $('.worldMap .yellow').addClass('active');
            }, 1200);
            setTimeout(function () {
              $('.worldMap .hq').addClass('active');
            }, 1500);
          }
        }

      });
    }
  });
}

// var url = document.location.href;
// if(!Cookies.get('news') && !url.includes('calculator')) {
// 	$('body').addClass('newsActive');
// }
//
// $('.news .icon-close').click(function(){
// 	$('body').removeClass('newsActive');
// 	Cookies.set('news', 1);
// });
